<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <Container
    v-editable="blok"
    class="pb-10 pt-2.5 lg:py-20"
    :style="{ backgroundColor: blok?.backgroundColor ?? 'inherit' }"
  >
    <div class="flex flex-col gap-5 lg:gap-[60px]">
      <div
        v-if="blok.heading || blok.subtitle"
        class="flex flex-col gap-5 pt-[30px] pb-5 md:pt-5 xl:py-5 w-full md:w-[700px]"
      >
        <Heading :heading="blok.heading" :subtitle="blok.subtitle" />
        <RichText
          v-editable="blok"
          :content="blok.description"
          class="!text-[19px] lg:!text-[21px] font-calson"
        />
      </div>

      <div
        class="pb-5 flex flex-col md:flex-row justify-between gap-[30px] md:gap-0"
      >
        <div
          v-for="column in blok.columns"
          :key="column._uid"
          class="flex flex-col gap-[26px] xl:w-[370px] lg:w-[300px] md:w-[230px] w-auto"
        >
          <Image
            v-for="image in column.image"
            :key="image._uid"
            class="sm:mx-0 -mx-2.5 max-w-full flex justify-end"
            :blok="{ image: image.image, ratio: '1x1' }"
          >
            <div v-if="image.association" class="p-2.5">
              <FavoriteButton :product-uuid="image.association" />
            </div>
          </Image>

          <div class="flex flex-col gap-4 lg:p-0">
            <BlokLink
              v-if="column.url?.cached_url"
              class="font-helvetica-bold flex justify-between items-start text-lg lg:text-xl"
              :blok="column.url"
              :is-form="column.isForm"
            >
              {{ column.heading }}
              <NuxtImg
                width="24px"
                height="24px"
                src="/icon/chevron-right-rounded.svg"
                alt="Chevron right"
              />
            </BlokLink>
            <div v-else class="font-helvetica-bold text-lg lg:text-xl">
              {{ column.heading }}
            </div>
            <RichText
              v-if="column.text"
              v-editable="column"
              class="xl:w-[350px] lg:w-[280px] md:w-[210px] pr-5 md:pr-0"
              :content="column.text"
              :class="blok.font"
            />
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>
